<!-- Page Wrapper -->
<div class="page-wrapper" style="min-height: 347px;">
    <div class="content container-fluid">
        <div class="bg-white page-border">
        <!--page body contant -->
            <!-- header  -->
            <div class="row row-replace add-m-b">
                <div class="col-md-6 col-p h5">MRF / RAISE NEW TICKET REQUEST FORM</div>
                <div class="col-md-6 top-corner-items col-p"> </div>
            </div>
        <!--end header row -->

        <ul class="nav nav-tabs nav-tabs-bottom">
            <li class="nav-item"><a class="nav-link active" href="#ticketmaster-tab1" data-toggle="tab">Servive Ticket</a></li>
            <li class="nav-item"><a class="nav-link" href="#ticketmaster-tab2" data-toggle="tab">Asset Ticket</a></li>
           
        </ul>
          
         <div class="tab-content">
            <nav class="tab-pane active" id="ticketmaster-tab1">
                    <div class="card flex-fill add-mrf-card bg-g-light">
                    <div class="card-body card-padding-bottom">
                        <!--first row-->
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Search Plant & Division By</label>
                                <select class="form-control">
                                    <option>Plant</option>
                                    <option>Region/Division</option>
                                    <option>Segment</option>
                                    <option>Team</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Select Division</label>
                                <select class="form-control">
                                    <option>Ak</option>
                                    <option>KP</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Search By</label>
                                <select class="form-control">
                                    <option>Tiket By</option>
                                    <option>Barcode By</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Ticket Id</label>
                                <input type="text" class="form-control" placeholder="Enter Ticket Id">
                            </div>
                            </div>
                        </div>
                        <!--second row -->
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Status</label>
                                <select class="form-control">
                                    <option>Open</option>
                                    <option>Assigned</option>
                                    <option>Work in Progress</option>
                                    <option>Resolved</option>
                                    <option>Closed</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Date Search By</label>
                                <select class="form-control">
                                    <option>Logged Date By</option>
                                    <option>Resolv Date By</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Date From</label>
                            <input type="date" class="form-control">
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Date To</label>
                                <input type="date" class="form-control">
                            </div>
                            </div>
                        </div>
                        <!--third row -->
                        <div class="row">
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Ticket Type</label>
                                <select class="form-control">
                                    <option>Asset Support</option>
                                    <option>Service Support</option>
                                
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Category</label>
                                <select class="form-control">
                                    <option>FN/None food Servie</option>
                                    <option>none vag</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Type Of Complaint</label>
                                <select class="form-control">
                                    <option> select Complaint</option>
                                </select>
                            </div>
                            </div>
                            <div class="col-xl-3 col-lg-3 col-md-12">
                            <div class="form-group">
                                <label>Concern</label>
                                <select class="form-control">
                                    <option>select Concern</option>
                                </select>
                            </div>
                            </div>
                        </div>
                        <!--end card-->
                    </div>
                    </div>
           
                <!--search row-->
                <div class="row row-replace add-p-tb">
                    <div class="col-12 text-center">            
                        <button class="btn btn-primary btn-sm"> Search</button>
                    </div>
                </div>
                <!--pagination row-->
                <div class="row row-replace">
                    <div class="col-12 col-pn">
                    <div class="card-table flex-fill">
                            <div class="card-body">
                                <div class="row">
                                <div class="col">            
                                    <label>       
                                        <select class="form-control">
                                            <option>100</option>
                                            <option>200</option>
                                            <option>300</option>
                                        </select>
                                    </label> 
                                    <label>Records</label>        
                                </div>
                                <div class="col">  
                                    <label class="float-right">       
                                    <input type="text" class="form-control">
                                </label>   
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--table row-->
                <div class="row row-replace">
                    <div class="col-12 col-pn">
                    <div class="card card-table flex-fill">
                        <div class="card-body">
                            <div class="table-responsive">
                                <table class="table custom-table mb-0">
                                <thead>
                                    <tr>
                                        <th>MRF ID</th>
                                        <th>Rasied On</th>
                                        <th>Site Name</th>
                                        <th>Employment Category</th>
                                        <th>Designation</th>
                                        <th>No of position	</th>
                                        <th>Pending</th>
                                        <th>Approved</th>
                                        <th>Assigned</th>
                                        <th>Interview In Progress</th>
                                        <th>Offered</th>
                                        <th>Closed</th>
                                        <th>Joined</th>
                                        <th>Re-Open</th>
                                        <th>Rejected</th>
                                        <th>Mrf Not Required</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td><a href="#">NA001</a></td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>
                                            <div class="dropdown action-label">
                                            <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="javascriptvoid(0);" data-toggle="dropdown" aria-expanded="false">
                                            <i class="fa fa-dot-circle-o text-success"></i> Active
                                            </a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-success"></i>
                                                Active</a>
                                                <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-danger"></i>
                                                Inactive</a>
                                            </div>
                                            </div>
                                        </td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>NA001</td>
                                        <td>
                                            <div class="dropdown dropdown-action">
                                            <a href="javascriptvoid(0);" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-pencil m-r-5"></i> Edit</a>
                                                <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
                                            </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                </table>
                            </div>
                        </div>
                        <!-- /organisation Table -->
                        <input type="hidden" id="get_org_routes" value="http://localhost/accesshr/setups/getOrganisations">
                    </div>
                    </div>
                </div>
                <!--end table -->
                <!--records show status row-->
                <div class="row row-replace">
                    <div class="col-12 col-pn">
                    <div class="card-table flex-fill">
                            <div class="card-body">
                                <div class="row">
                                <div class="col">            
                                    <label>Showing 0 to 0 of 0 entries</label>        
                                </div>
                                <div class="col">  
                                    <label class="float-right">       
                                        <ul class="pagination">
                                            <li class="page-item previous disabled">
                                                <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                            </li>
                                            <li class="page-item active">
                                                <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                            </li>
                                            <li class="page-item next disabled"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                            </li>
                                        </ul>
                                    </label>   
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </nav>
           <!--Asset Ticket tab-->
            <nav class="tab-pane" id="ticketmaster-tab2">
                        <div class="card flex-fill add-mrf-card bg-g-light">
                            <div class="card-body card-padding-bottom">
                                <!--first row-->
                                <div class="row">
                                    <div class="col-xl-6 col-lg-6 col-md-12">
                                    <div class="form-group">
                                        <label>Search Plant & Division By</label>
                                        <select class="form-control">
                                            <option>Plant</option>
                                            <option>Region/Division</option>
                                            <option>Segment</option>
                                            <option>Team</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-6 col-lg-6 col-md-12">
                                    <div class="form-group">
                                        <label>Select Division</label>
                                        <select class="form-control">
                                            <option>Ak</option>
                                            <option>KP</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                <!--second row -->
                                <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Status</label>
                                        <select class="form-control">
                                            <option>Open</option>
                                            <option>Assigned</option>
                                            <option>Work in Progress</option>
                                            <option>Resolved</option>
                                            <option>Closed</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Date Search By</label>
                                        <select class="form-control">
                                            <option>Logged Date By</option>
                                            <option>Resolv Date By</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Date From</label>
                                       <input type="date" class="form-control">
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Date To</label>
                                        <input type="date" class="form-control">
                                    </div>
                                    </div>
                                </div>
                                <!--third row -->
                                <div class="row">
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Ticket Type</label>
                                        <select class="form-control">
                                            <option>Asset Support</option>
                                            <option>Service Support</option>
                                           
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Category</label>
                                        <select class="form-control">
                                            <option>FN/None food Servie</option>
                                            <option>none vag</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Type Of Complaint</label>
                                        <select class="form-control">
                                            <option> select Complaint</option>
                                        </select>
                                    </div>
                                    </div>
                                    <div class="col-xl-3 col-lg-3 col-md-12">
                                    <div class="form-group">
                                        <label>Concern</label>
                                        <select class="form-control">
                                            <option>select Concern</option>
                                        </select>
                                    </div>
                                    </div>
                                </div>
                                <!--end card-->
                            </div>
                            </div>
                       
                            <!--search row-->
                            <div class="row row-replace add-p-tb">
                                <div class="col-12 text-center">            
                                    <button class="btn btn-primary btn-sm"> Search</button>
                                </div>
                            </div>
                            <!--pagination row-->
                            <div class="row row-replace">
                                <div class="col-12 col-pn">
                                <div class="card-table flex-fill">
                                        <div class="card-body">
                                            <div class="row">
                                            <div class="col">            
                                                <label>       
                                                    <select class="form-control">
                                                        <option>100</option>
                                                        <option>200</option>
                                                        <option>300</option>
                                                    </select>
                                                </label> 
                                                <label>Records</label>        
                                            </div>
                                            <div class="col">  
                                                <label class="float-right">       
                                                <input type="text" class="form-control">
                                            </label>   
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!--table row-->
                            <div class="row row-replace">
                                <div class="col-12 col-pn">
                                <div class="card card-table flex-fill">
                                    <div class="card-body">
                                        <div class="table-responsive">
                                            <table class="table custom-table mb-0">
                                            <thead>
                                                <tr>
                                                    <th>MRF ID</th>
                                                    <th>Rasied On</th>
                                                    <th>Site Name</th>
                                                    <th>Employment Category</th>
                                                    <th>Designation</th>
                                                    <th>No of position	</th>
                                                    <th>Pending</th>
                                                    <th>Approved</th>
                                                    <th>Assigned</th>
                                                    <th>Interview In Progress</th>
                                                    <th>Offered</th>
                                                    <th>Closed</th>
                                                    <th>Joined</th>
                                                    <th>Re-Open</th>
                                                    <th>Rejected</th>
                                                    <th>Mrf Not Required</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td><a href="#">NA001</a></td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>
                                                        <div class="dropdown action-label">
                                                        <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="javascriptvoid(0);" data-toggle="dropdown" aria-expanded="false">
                                                        <i class="fa fa-dot-circle-o text-success"></i> Active
                                                        </a>
                                                        <div class="dropdown-menu dropdown-menu-right">
                                                            <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-success"></i>
                                                            Active</a>
                                                            <a class="dropdown-item" href="javascriptvoid(0);"><i class="fa fa-dot-circle-o text-danger"></i>
                                                            Inactive</a>
                                                        </div>
                                                        </div>
                                                    </td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>NA001</td>
                                                    <td>
                                                        <div class="dropdown dropdown-action">
                                                        <a href="javascriptvoid(0);" class="action-icon dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><i class="material-icons">more_vert</i></a>
                                                        <div class="dropdown-menu dropdown-menu-right">
                                                            <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-pencil m-r-5"></i> Edit</a>
                                                            <a class="dropdown-item" href="javascript:void(0)"><i class="fa fa-trash-o m-r-5"></i> Delete</a>
                                                        </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <!-- /organisation Table -->
                                    <input type="hidden" id="get_org_routes" value="http://localhost/accesshr/setups/getOrganisations">
                                </div>
                                </div>
                            </div>
                            <!--end table -->
                            <!--records show status row-->
                            <div class="row row-replace">
                                <div class="col-12 col-pn">
                                <div class="card-table flex-fill">
                                        <div class="card-body">
                                            <div class="row">
                                            <div class="col">            
                                                <label>Showing 0 to 0 of 0 entries</label>        
                                            </div>
                                            <div class="col">  
                                                <label class="float-right">       
                                                    <ul class="pagination">
                                                        <li class="page-item previous disabled">
                                                            <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="0" tabindex="0" class="page-link">Previous</a>
                                                        </li>
                                                        <li class="page-item active">
                                                            <a href="#" aria-controls="DataTables_Table_0" data-dt-idx="1" tabindex="0" class="page-link">1</a>
                                                        </li>
                                                        <li class="page-item next disabled"><a href="#" aria-controls="DataTables_Table_0" data-dt-idx="2" tabindex="0" class="page-link">Next</a>
                                                        </li>
                                                    </ul>
                                                </label>   
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                 
             </nav>

        <!--end tab-->
        </div> 
                
        <!--end page body contant -->
        </div>
    </div>
</div>
  <!-- /Page Wrapper -->




 


